var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 98,
    viewBox: "0 0 292 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 427.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      clipPath: "url(#bgblur_0_5953_7152_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.393 45.0811L120.075 44.1216C116.562 43.45 115.76 43.0662 115.76 41.2433C115.76 39.4202 116.964 38.6528 120.877 38.6528C125.293 38.6528 126.597 39.6122 126.597 42.6825V43.1622L133.22 41.4351C132.719 36.4459 129.006 32.8 121.078 32.8C112.448 32.8 109.137 37.1176 109.137 41.5311C109.137 46.0405 111.545 48.727 117.265 49.6866L122.583 50.55C126.798 51.2217 127.3 51.8933 127.3 53.8122C127.3 55.7312 126.397 56.4987 122.483 56.4987C117.064 56.4987 115.86 55.6352 115.86 52.4689V51.9893L109.237 53.7163C109.739 59.3771 113.853 62.3515 122.082 62.3515C130.611 62.3515 133.823 58.2257 133.823 53.6203C133.923 49.4946 131.715 46.3285 125.393 45.0811Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.659 49.4792C158.659 44.2021 154.244 40.6521 148.223 40.6521C140.697 40.6521 136.382 45.0657 136.382 51.9738C136.382 58.786 140.396 63.1035 147.821 63.1035C154.043 63.1035 158.559 59.5536 158.559 54.2764V53.7968H151.835V54.0846C151.835 56.4833 150.43 57.3468 147.621 57.3468C144.409 57.3468 143.005 55.9076 143.005 51.8779C143.005 47.8482 144.409 46.4089 147.621 46.4089C150.43 46.4089 151.835 47.1765 151.835 49.6711V50.0549H158.659V49.4792Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.205 40.5563C165.883 40.5563 161.668 43.9144 161.668 49.0954V49.5752L168.091 49.0954C168.091 46.8887 169.195 46.2171 171.904 46.2171C174.513 46.2171 176.018 46.6967 176.018 49.1914V49.863L168.291 51.0143C163.675 51.6859 161.167 53.7968 161.167 57.0589C161.167 60.9928 164.277 63.0077 168.291 63.0077C172.506 63.0077 174.714 61.2806 176.018 59.6496H176.319V62.5279H182.541V49.767C182.341 44.1062 178.827 40.5563 172.205 40.5563ZM170.399 58.1144C168.392 58.1144 167.489 57.7306 167.489 56.5793C167.489 55.7157 168.091 55.236 169.495 55.0441L175.918 54.0846C175.918 57.4427 173.108 58.1144 170.399 58.1144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.355 35.5668V62.6238H193.079V33.8398L186.355 35.5668Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.293 35.5668V62.6238H204.016V33.8398L197.293 35.5668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.667 40.5563C211.442 40.5563 207.127 44.9697 207.127 51.7819C207.127 58.5941 211.442 63.0077 218.667 63.0077C225.892 63.0077 230.107 58.5941 230.107 51.7819C230.107 44.9697 225.892 40.5563 218.667 40.5563ZM218.874 57.7489C215.445 57.7489 212.657 55.0723 212.657 51.7819C212.657 48.4917 215.445 45.8149 218.874 45.8149C219.393 45.8149 219.912 45.8763 220.424 45.9991C220.528 46.0297 220.624 46.0988 220.671 46.1908L220.771 46.3775C221.513 47.7641 222.781 48.8234 224.314 49.3353C224.475 49.389 224.579 49.5272 224.579 49.6882V53.8681C224.579 54.0291 224.475 54.1672 224.314 54.221C222.781 54.733 221.51 55.7907 220.766 57.176L220.663 57.3655C220.615 57.4651 220.52 57.5343 220.415 57.5572C219.904 57.6876 219.385 57.7489 218.874 57.7489Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.365 40.5563C242.953 40.5563 240.344 41.8035 239.138 44.2022H238.939V41.0359H232.717V69.8198L239.441 68.0927V59.7454H239.641C240.645 61.5685 242.852 63.0077 246.465 63.0077C252.586 63.0077 255.998 58.5941 255.998 51.7819C256.098 44.9697 252.686 40.5563 246.365 40.5563ZM244.358 57.5387C241.146 57.5387 239.441 56.4833 239.441 53.509V50.0549C239.441 47.1765 241.247 46.0251 244.358 46.0251C248.271 46.0251 249.275 47.8482 249.275 51.7819C249.275 55.7157 248.271 57.5387 244.358 57.5387Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.608 25.2202C71.1409 29.6379 66.6737 34.0394 62.2066 38.4572C62.1558 38.4896 62.1219 38.5221 62.0711 38.5708L52.3415 47.9097C51.4109 48.803 51.4109 50.281 52.3415 51.1743L61.5635 60.0261L50.2095 71.444C48.4497 70.2908 46.7745 68.959 45.1162 67.351C33.2207 55.9494 32.8146 41.8516 44.7947 30.3363C54.2874 21.2247 65.4893 19.6818 75.608 25.2202Z",
    fill: "url(#paint0_linear_5953_7152)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5951 67.5623C74.1192 76.6413 62.9852 78.2655 52.9339 73.052L56.9273 69.0403C59.9901 66.0031 63.0359 62.9822 66.0987 59.945L75.2191 51.1908C76.1498 50.2975 76.1498 48.8195 75.2191 47.9262L66.0648 39.1395L77.3004 27.8514L78.2818 26.8769C79.9401 27.9976 81.5983 29.3457 83.172 30.8561C94.966 42.1441 95.4737 56.1444 83.5951 67.5623Z",
    fill: "url(#paint1_linear_5953_7152)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5953_7152_clip_path",
    transform: "translate(67.8693 67.8693)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5953_7152",
    x1: 216.54,
    y1: 2.17529,
    x2: 198.568,
    y2: 210.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37798,
    stopColor: "#3A8AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6AF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5953_7152",
    x1: 85.2091,
    y1: 8.84255,
    x2: 14.9663,
    y2: 168.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37798,
    stopColor: "#3A8AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6AF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group (2).f9b06373865d327c00de7b19c4c7ca5c.svg";
export { ForwardRef as ReactComponent };